import { Injectable } from '@angular/core';
import { hasStoredTheme } from '@huddle-sports-platform/ui';

/**
 * The theme ask's gate - whether the person has ever CHOSEN a look.
 *
 * Storage is the state (the kit's `huddle-theme` key: a stored choice is
 * the answer, its absence is "never asked"), so unlike the notifications
 * ask there is no session flag: the chooser page persists whatever the
 * person picks - including Continue-without-touching-anything, which
 * records the theme already showing - and the ask never comes back.
 *
 * A thin injectable rather than a bare import so `Landing`'s spec can stub
 * the answer like every other rule's store.
 */
@Injectable({ providedIn: 'root' })
export class ThemeAsk {
  shouldAsk(): boolean {
    return !hasStoredTheme();
  }
}
